import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

function AnimatedCounter({ end, duration, suffix }) {
  const [count, setCount] = useState(0);
  const [started, setStarted] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting && !started) setStarted(true); },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [started]);

  useEffect(() => {
    if (!started) return;
    const steps = 60;
    let current = 0;
    const increment = end / steps;
    const timer = setInterval(() => {
      current += increment;
      if (current >= end) { setCount(end); clearInterval(timer); }
      else setCount(Math.floor(current));
    }, (duration || 1800) / steps);
    return () => clearInterval(timer);
  }, [started, end, duration]);

  return <span ref={ref}>{count.toLocaleString()}{suffix}</span>;
}

function Stats() {
  const { t } = useTranslation();

  const stats = [
    { value: 4,   suffix: '',  label: t('stats.poles',      { defaultValue: "Pôles d'activité" }) },
    { value: 24,  suffix: 'h', label: t('stats.turnaround', { defaultValue: 'Délai de devis gratuit' }) },
    { value: 1,   suffix: '+', label: t('stats.years',      { defaultValue: "Ans d'expérience terrain" }) },
    { value: 2,   suffix: '',  label: t('stats.languages',  { defaultValue: 'Langues de travail (FR/EN)' }) },
  ];

  return (
    <section className="stats-section" id="stats">
      <div className="stats-grid">
        {stats.map((s, i) => (
          <div key={i} className="stat-card">
            <div className="stat-value">
              <AnimatedCounter end={s.value} suffix={s.suffix} />
            </div>
            <div className="stat-label">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Stats;
